export const COACH_ACTIVITY_TENANT_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
};

export const COACH_ACTIVITY_TENANT_COACH_TYPE = {
  FREELANCE: 'Freelance',
  MANAGED: 'Managed'
};

export const getBadgeVariant = (status) => {
  switch (status) {
    case COACH_ACTIVITY_TENANT_STATUS.PENDING:
      return 'outline';
    case COACH_ACTIVITY_TENANT_STATUS.APPROVED:
      return 'secondary';
    case COACH_ACTIVITY_TENANT_STATUS.REJECTED:
      return 'destructive';
    default:
      return 'default';
  }
};
